import { render, staticRenderFns } from "./pubsfc.vue?vue&type=template&id=525f0c60&scoped=true&"
import script from "./pubsfc.vue?vue&type=script&lang=js&"
export * from "./pubsfc.vue?vue&type=script&lang=js&"
import style0 from "./pubsfc.vue?vue&type=style&index=0&id=525f0c60&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f0c60",
  null
  
)

export default component.exports